export const ADD_PAYMENT = "/payments/:id/add_payment/";
export const UPDATE_PAYMENT = "/payments/:id/:paymentId/update";
